import {
  ComponentsProvider,
  NovaReservaComponent,
} from "@gvdasa/components-gestaoreservas";
import { useUsuarioLogadoContext } from "../../shared/contexts/UsuarioLogadoInfoReservaContext";
import { useSearchParams } from "react-router-dom";
import {
  getEnvironmentFromUrl,
  getOriginFromUrl,
} from "../../shared/utils/urlHelper";
import { useMemo } from "react";

export const NovaReserva = () => {
  const { idTenant, isLoadingUsuarioLogadoInfo, isErrorUsuarioLogadoInfo } =
    useUsuarioLogadoContext();

  const [searchParams] = useSearchParams();

  const token = searchParams.get("token") || "";
  const tenant = searchParams.get("tenant") || "";

  const environment = useMemo(() => {
    const envParams = searchParams.get("environment");
    return getEnvironmentFromUrl(envParams) || "dev";
  }, [searchParams]);

  const origin = useMemo(
    () => getOriginFromUrl(searchParams.get("origin")),
    [searchParams],
  );

  if (isLoadingUsuarioLogadoInfo || isErrorUsuarioLogadoInfo || !idTenant) {
    return null;
  }

  return (
    <ComponentsProvider
      tenant={tenant || idTenant}
      environment={
        (process.env.REACT_APP_ENV as "prod" | "hml" | "dev") || "dev"
      }
      handleGetToken={async () => token}
      {...(!!origin && { origin })}
    >
      <NovaReservaComponent />
    </ComponentsProvider>
  );
};
